/** @jsxImportSource @emotion/react */

export const colors = {
  hitmap1: '#A92222',
  hitmap2: '#BF4F4F',
  hitmap3: '#D47B7B',
  hitmap4: '#E9A8A8',
  hitmap5: '#FED4D4',

  black: '#3b3a39',
  bg: '#F0F0F0',
};
